import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SelectedLocationsState {
  mode: 'AND' | 'OR'; // AND / OR mode for multiple filters
  filters: Record<string, string[] | string>;
  storeCodes: string[]; // optional; you can just keep []
}

const KEY = 'selected-locations';

@Injectable({ providedIn: 'root' })
export class SelectedLocationsStore {
  private _state$ = new BehaviorSubject<SelectedLocationsState | null>(read());
  state$ = this._state$.asObservable();

  set(state: SelectedLocationsState) {
    sessionStorage.setItem(KEY, JSON.stringify(state));
    this._state$.next(state);
  }

  clear() {
    sessionStorage.removeItem(KEY);
    this._state$.next(null);
  }

  get snapshot() {
    return this._state$.value;
  }
}

function read(): SelectedLocationsState | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
